export function formatInJapanese(value) {
  let isApproximate = false;
  let formatted = '';
  let unitValue = 0;
  if (value >= 1000000000000) {
    if (value % 1000000000000 !== 0) {
      isApproximate = true;
    }
    unitValue = Math.floor(value / 1000000000000);
    formatted += `${unitValue}兆`;
    value -= unitValue * 1000000000000;
  }
  if (value >= 100000000) {
    if (value % 100000000 !== 0 && !isApproximate) {
      isApproximate = true;
    }
    unitValue = Math.floor(value / 100000000);
    value -= unitValue * 100000000;
    formatted += `${unitValue}億`;
  }
  if (value >= 10000) {
    if (value % 10000 !== 0 && !isApproximate) {
      isApproximate = true;
    }
    unitValue = Math.floor(value / 10000);
    value -= unitValue * 10000;
    formatted += `${unitValue}万`;
  }

  return `${formatted}円`;
}
